import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation'
import Footer from '../components/Footer'
import { footerEn /* footerAr*/ } from '../data/footer'
import { researchTraining, navigationTop, navigationButtom } from '../params'
import ResearchTrainingLearningPaths from '../components/Compliance/ResearchTrainingLearningPaths';




const ResearchTrainingPaths = ({ updateLang }) => {
    const [htmlContent, setHtmlContent] = React.useState('');
    const [dynamicRoutes, setDynamicRoutes] = useState(researchTraining);

    document.title = 'Recommended Learning Paths ';
    const headerData = {
        title: 'Recommended Learning Paths ',
        crumb: [
            { link: '//', text: 'Home' },
            { link: '/', text: 'Research' },
            { link: '/research/online-training', text: 'Online Training' },
            { link: '/research/research-training-paths', text: 'Recommended Learning Paths ' },
        ],
        navigationButtom: researchTraining // Add this if you want bottom navigation as well
    };

    return (
        <>
            <Navigation
                {...headerData}
                // researchTraining={[]}
                updateLang={updateLang}
            />
            {/* <NewsBanner {...HeaderBanner} coreLab={true} /> */}
            <section className='space-block-60'>
                <div className='container'>
                  <ResearchTrainingLearningPaths />
                </div>
            </section>
            <Footer {...footerEn} />
        </>
    );
};

export default ResearchTrainingPaths;
